import React from "react"
import {chooseColor} from "../../../../../../../function/base/shapeFunc"
import {Shape} from "react-konva"
import {Dispatch} from "redux"
import {ContentItem, LocationShape, OncePageCanvasData} from "../../../../../../../reducer/interface/dataInterface"

interface TDAShapeProps {
    dispatch: Dispatch
    mapping: string
    hoverItem: ContentItem | null
    data: TDAShapeCanvasData
    handleClickShape: (data: any) => void
}

export interface TDAShapeCanvasData {
    diffIndex: number
    diffType: "delete" | "insert" | "replace"
    data: any
    allShapeData: LocationShape
}

const TDAShape: React.FunctionComponent<TDAShapeProps> = (props) => {
    const dispatch = props.dispatch
    const diffIndex = props.data.diffIndex
    const mapping = props.mapping
    const diffType = props.data.diffType
    const position = props.data.data

    const lineShape = (context: any, shape: any) => {
        context.beginPath()
        context.moveTo(position.leftBottom.x, position.leftBottom.y)
        context.lineTo(position.leftTop.x, position.leftTop.y)
        context.lineTo(position.rightTop.x, position.rightTop.y)
        context.lineTo(position.rightBottom.x, position.rightBottom.y)
        context.lineTo(position.leftBottom.x, position.leftBottom.y)
        context.closePath()
        context.fillStrokeShape(shape)
    }

    return (
        <Shape
            x={0}
            y={0}
            id={diffIndex.toString()}
            name={`${diffType}Shape`}
            fill={
                props.hoverItem && props.hoverItem.diffIndex === diffIndex
                    ? chooseColor(diffType).active
                    : chooseColor(diffType).fill
            }
            stroke={props.hoverItem && props.hoverItem.diffIndex === diffIndex ? chooseColor(diffType).stroke : ""}
            strokeWidth={3}
            onMouseEnter={() => {
                if (!props.hoverItem || props.data.diffIndex !== props.hoverItem.diffIndex) {
                    dispatch({type: "changeHoverDiffitem", payload: props.data})
                }
            }}
            onClick={(e) => {
                props.handleClickShape(props.data)
            }}
            sceneFunc={lineShape}
        />
    )
}
export default TDAShape
